import { render, staticRenderFns } from "./InvestmentRepointRequests.vue?vue&type=template&id=31498ed4"
import script from "./InvestmentRepointRequests.vue?vue&type=script&lang=ts"
export * from "./InvestmentRepointRequests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports